import { datadogLogs } from '@datadog/browser-logs';
import { toastError } from '@onestep/coreui/Toast';

import { getErrorMessage } from '@/utils/errorUtil';
import { httpStatusOf } from '@/utils/httpStatusOf';

export const recordServerError = (
  errorKey: string,
  context: Record<string, unknown>,
  error: unknown,
) => {
  datadogLogs?.logger?.error(errorKey, {
    ...context,
    status: httpStatusOf(error),
    error_message: getErrorMessage(error),
  });
};

export const logServerError = (
  errorKey: string,
  toastMessage: string,
  context: Record<string, unknown>,
  error: unknown,
) => {
  recordServerError(errorKey, context, error);
  toastError({ content: toastMessage, toastId: errorKey });
};
